import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-empty-notes',
  templateUrl: './empty-notes.component.html',
  styleUrls: ['./empty-notes.component.scss']
})
export class EmptyNotesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
